import { NEXT_PUBLIC_IMAGE_URL } from "@/common";

export const learningintro = [
  {
    versionA: {
      title: "Có job rồi, giờ phải 'lên level' để có job xịn hơn.",
      description:
        'Không cần cày bừa tài liệu tràn lan. Upzi gợi ý sách, khoá học, video, podcast phù hợp với từng giai đoạn nghề nghiệp.',
      image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/learning.png`,
    },
    versionB: {
      title: 'Phát triển kỹ năng với lộ trình học tập thông minh',
      description:
        'Từng bước nâng cao năng lực với các tài liệu được AI tuyển chọn phù hợp với mục tiêu nghề nghiệp của bạn.',
      image: `${NEXT_PUBLIC_IMAGE_URL}/image/landing-page/learning.png`,
    },
  },
];
